import React, { useState, useRef, useImperativeHandle } from 'react';
import { Spin, message } from 'antd';
import FormCategories from '../FormCategories/FormCategories'; 
import FormSaveCancelToolbar from '../FormSaveCancelToolbar/FormSaveCancelToolbar'; 
import courseFormUtils from '../../pages/CourseEditPage/courseFormUtils';
import useSyncObjectRelationships from '../../gql/hooks/useSyncObjectRelationships';

const TabCategories = ( { form, isSavingCallback, ref } ) => { 
    const formCategoriesRef = useRef( useRef );
    const [ isSaving, setIsSaving ] = useState( false );
    const [ isModified, setIsModified ] = useState( false );
    const [ sync ] = useSyncObjectRelationships();
    const [ openConfirm, setOpenConfirm ] = useState( false );

    useImperativeHandle( ref, () => ( {
        isModified() {
            return isModified;
        },
        showSaveConfirm() {
            setOpenConfirm( true );
        }
    } ) );

    const handleSave = async () => {
        setIsSaving( true );
        isSavingCallback( true ); 
        setOpenConfirm( false );  

        const syncData = courseFormUtils.getCategorySyncValues( form );

        if ( syncData ) {
            try {
                await sync( { variables: { input: syncData } } );
                courseFormUtils.updateCategoryValues( form, syncData.relatedResourceIds );
                formCategoriesRef.current.reset();
                message.success( 'Course saved.' );
            } catch ( error ) { 
                console.error( 'Error saving!', error );  
                message.error( 'Error saving!' );   
            } 
        }

        setIsSaving( false );
        isSavingCallback( false );
    };

    const handleReset = () => {
        formCategoriesRef.current.reset();
        setOpenConfirm( false );
        isSavingCallback( false );
    };

    const handleModifiedChange = ( value ) => {
        setIsModified( value );
    };

    return (
        <div className="resources-tab tab-main-columns">
            <div className="left">
                <Spin spinning={ isSaving }>
                    <FormCategories 
                        form={ form }
                        ref={ formCategoriesRef }
                        modifiedCallback={ handleModifiedChange } 
                    />
                </Spin>
            </div>

            <div className="right">
                <FormSaveCancelToolbar
                    form={ form } 
                    open={ openConfirm }
                    saving={ isSaving }
                    modified={ isModified }
                    saveCallback={ handleSave }
                    cancelCallback={ handleReset }
                />
            </div>
        </div>
    );
};

export default TabCategories;
